 
export const handleSearchChange = (setSearchQuery, setCurrentPage) => (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // Reset to first page on new search
};

export const handleFilterTypeChange = (setFilterType, setSearchQuery) => (event) => {
    setFilterType(event.target.value);
    setSearchQuery(''); // Reset search query when filter type changes
};

export const filterTransactions = (transactions, query, filterType) => {
    if (!transactions || !Array.isArray(transactions)) {
      return [];
    }
  
    return transactions.filter(transaction => {
      if (!transaction) return false;
  
      const valueToCheck = transaction[filterType] || '';
      return valueToCheck.toString().toLowerCase().includes(query.toLowerCase());
    });
  };